import type { BaseSlideProps, NarrativeContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function NarrativeSlide({ title, content, accentColor }: BaseSlideProps) {
  const { text, sidebar } = content as NarrativeContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 accent-text">
        {title}
      </h2>

      <div className={sidebar ? 'split-layout' : ''}>
        {/* Main narrative text */}
        <div className="prose prose-lg max-w-none">
          {text.split('\n\n').map((paragraph, idx) => (
            <p key={idx} className="mb-4 text-slate-700 dark:text-slate-300 leading-relaxed"
               dangerouslySetInnerHTML={{ __html: inlineMarkdown(paragraph.trim()) }} />
          ))}
        </div>

        {/* Optional sidebar */}
        {sidebar && (
          <div className="card accent-border-left">
            <h3 className="font-serif font-semibold text-lg mb-3 accent-text">
              {sidebar.type}
            </h3>
            {sidebar.items && (
              <ul className="space-y-2">
                {sidebar.items.map((item, idx) => (
                  <li key={idx} className="text-sm text-slate-600 dark:text-slate-400">
                    • <span dangerouslySetInnerHTML={{ __html: inlineMarkdown(item) }} />
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
